import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {namesAndIDs, truBlueSanitizers, truBlueMaintOxidizers, truBluePrevAlgicides} from 'helpers/truBlue';

import {Row, Col, Card} from 'components';
import {Icon} from 'components/layout';
import {Select, Checkbox} from 'components/forms';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import ToolTip, {tooltipPositions} from 'components/ToolTip';

class TruBluePreferences extends Component {
  static propTypes = {
    formatMessage: intlShape.isRequired,
    intl: intlShape.isRequired,
  };

  render() {
    let {dealer, edit, onChange, products} = this.props;
    let {formatMessage} = this.props.intl;

    if (!dealer.isTruBlueEligible) {
      return null;
    }

    let [sanitizerOptions, sanitizerKeys] = namesAndIDs(truBlueSanitizers(products, dealer));
    let selectedSanitizer = dealer.truBlueSanitizer || sanitizerKeys[0];
    let selectedSanitizerChemicalBaseType = products.find(p => p.id === selectedSanitizer).chemicalBaseTypeID;

    let [maintOxidizerOptions, maintOxidizerKeys] = namesAndIDs(truBlueMaintOxidizers(products, dealer, selectedSanitizerChemicalBaseType));
    let [prevAlgicideOptions, prevAlgicideKeys] = namesAndIDs(truBluePrevAlgicides(products, dealer, selectedSanitizerChemicalBaseType));

    let selectedMaintOxidizer = dealer.truBlueMaintOxidizer || maintOxidizerKeys[0];
    let selectedPrevAlgicide = dealer.truBluePrevAlgicide || prevAlgicideKeys[0];

    return <div>
      <h2>
        <Icon name='tru-blue-filled'/>
        <FormattedMessage id="preferences.trublue.products"/>
        <ToolTip title={formatMessage({id: 'preferences.analysis.trublue.tooltip'})}
                 position={tooltipPositions.topRight}
                 iconOnly
                 style={{float: 'right'}}/>
      </h2>
      <Card fullWidth>
        <Row>
          <Col md={4}>
            <Select label={formatMessage({id: 'general.sanitizers'})}
                    editMode={edit}
                    dataKey='truBlueSanitizer'
                    value={selectedSanitizer}
                    dataChanged={onChange}
                    options={sanitizerOptions}
                    keys={sanitizerKeys}/>
          </Col>

          <Col md={4}>
            <Select label={formatMessage({id: 'general.maint.oxidizer'})}
                    editMode={edit}
                    dataKey='truBlueMaintOxidizer'
                    value={selectedMaintOxidizer}
                    dataChanged={onChange}
                    options={maintOxidizerOptions}
                    keys={maintOxidizerKeys}/>
          </Col>

          <Col md={4}>
            <Select label={formatMessage({id: 'general.prev.algicide'})}
                    editMode={edit}
                    dataKey='truBluePrevAlgicide'
                    value={selectedPrevAlgicide}
                    dataChanged={onChange}
                    options={prevAlgicideOptions}
                    keys={prevAlgicideKeys}/>
          </Col>

          <Col md={4}>
            <Checkbox topLabel={formatMessage({id: 'general.maint.clarifier'})}
                      label={formatMessage({id: 'general.pool.complete'})}
                      editMode={edit === true && dealer.truBlueOptimizerPlus === true}
                      dataKey='truBluePoolComplete'
                      value={dealer.truBluePoolComplete || !dealer.truBlueOptimizerPlus} // Can only change if opt. plus
                      dataChanged={onChange}/>
          </Col>

          <Col md={4}>
            <Checkbox topLabel={formatMessage({id: 'general.water.enhancer'})}
                      label={formatMessage({id: 'general.optimizer.plus'})}
                      editMode={edit}
                      dataKey='truBlueOptimizerPlus'
                      value={dealer.truBlueOptimizerPlus}
                      dataChanged={onChange}/>
          </Col>
        </Row>
      </Card>
    </div>;
  }
}

TruBluePreferences.propTypes = {
  dealer: PropTypes.object.isRequired,
  edit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  products: PropTypes.func.isRequired,
};
TruBluePreferences.defaultProps = {
  edit: false,
};

export default injectIntl(TruBluePreferences);
